import React, { useState, useEffect } from "react";
import axios from 'axios'
import Swal from 'sweetalert2';

import Guest from "../../../layouts/Guest";
import ChingMingCheckInConfirmation from "../../../components/Private/CheckIn/ChingMingCheckInConfirmation";
import { useGuestContext } from '../../../contexts/GuestContext';
import { getEventPin, handlePinAuthError } from "../../../utils/pinAuth";

function ChingMingCheckInPage() {
  const [details, setDetails] = useState(null);
  const [guestId, setGuestId] = useState(null);
  const { language } = useGuestContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // First, try to get 'guestid' from the URL
    let id = params.get('guestid');
    // If 'guestid' is not found, try to get 'id' instead
    if (!id) {
      id = params.get('id');
    }
    // Proceed if any of the IDs were found
    if (id) {
      setGuestId(id);
      fetchGuestDetails(id);
    }
  }, []);
  

  const fetchGuestDetails = async (guestId) => {
    try {
      const pin = await getEventPin();
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/chingming/checkinrequest?guestid=${guestId}`, {
          headers: { 'X-Event-Pin': pin }
      });
      if (response.data && response.data.status === 'success') {
        console.log(response.data.details)
        setDetails(response.data.details);
      } else if (response.data && response.data.status === 'checkedIn') {
        // Guest is already checked in
        const checkedInTime = response.data.details.checkedInTime || 'Unknown time';
        Swal.fire({
          title: language === "English" ? `Guest already checked in` : `居士已報到`,
          text: language === "English" ? `The guest with ID: ${guestId} has already checked in at ${checkedInTime}.` : `ID為${guestId}的居士已於 ${checkedInTime} 報到。`,
          icon: 'warning',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/checkinSearch';
        });
      } else {
        // Handle other error or failed status
        Swal.fire({
          title: language === "English" ? `The Guest with ID: ${guestId} not found` : `未找到ID為${guestId}的居士`,
          text: language === "English" ? "Please ensure the guest has completed the registration" : "請確認這位居士已完成報名",
          icon: 'error',
          confirmButtonText: 'OK',
          allowOutsideClick: false
        }).then(() => {
          window.location.href = '/checkinSearch';
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
          handlePinAuthError();
      } else {
          // Handle HTTP errors
          Swal.fire('Error', 'An error occurred while fetching data', 'error').then(() => {
            window.location.href = '/checkinSearch';
          });
      }
    }
  };


  return (
    <>
      <Guest>
        {details && <ChingMingCheckInConfirmation details={details} />}
      </Guest>
    </>
  );
}

export default ChingMingCheckInPage;
